export default class GoBack {
  constructor(element) {
    element.addEventListener('click', () => {
      this.historyBack()
    });
  }

  historyBack() {
    history.back();
  }
}